<template>
    <div>
        <a-tabs @change="tabChange">
            <a-tab-pane key="custom" tab="自定义页面">
                <div class="tab-summary">
                    说明：该页面可完全自由设计，呈现你想呈现的长图信息，页面名称也可根据呈现的信息自由命名；为提升用户页面访问速度，建议该页长图压缩至4M以内
                </div>
                
                <div class="at-input-group">
                    <span class="label">自定义首页内容图片：</span>
                    <upload-image style="max-width: 150px" v-model="item.page_custom_index_image"
                        @change="triggerPreview" />
                    <div class="pay-apply-tips">
                        图片格式必须为：png,bmp,jpeg,jpg；不可大于4M；
                        建议使用png格式图片，以保持最佳效果；
                        建议图片宽度为980px
                    </div>
                </div>

            </a-tab-pane>

            <a-tab-pane key="card" tab="首页" style="position: relative;">
                <div class="row" style="padding-bottom: 20px;">
                    <div class="row">
                        <span class="label">AI检测机器人：</span>
                        <a-switch checked-children="开" v-model="item.index_robot" un-checked-children="关"
                            @change="triggerPreview" />
                    </div>
                </div>
                <div class="row ml-4" v-if="isDisabled('page_card_enabled')" style="margin-bottom: 20px;">
                </div>
                <div class="at-input-group" v-if="editTemplate != 2">
                    <pay-box title="名片模版" style="width: 696px" v-if="editTemplate == 0">
                        <div class="card-templates">
                            <div class="card-template" :class="{ 'template-active': item.page_card_style == 'style1' }"
                                @click="item.page_card_style = 'style1'">
                                <div class="card-head">
                                    <div class="left">
                                        <div class="point"></div>
                                        <div class="label">模板一</div>
                                    </div>
                                    <div class="right" @click="editTemplate = 1">
                                        <div>编辑</div>
                                        <div class="line"></div>
                                        <div>预览</div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <mp-card :app-config="config" />
                                </div>
                            </div>
                            <div class="card-template" :class="{ 'template-active': item.page_card_style == 'style2' }"
                                @click="item.page_card_style = 'style2'">
                                <div class="card-head">
                                    <div class="left">
                                        <div class="point"></div>
                                        <div class="label">模板二</div>
                                    </div>
                                    <div class="right" @click="editTemplate = 2">
                                        <div>编辑</div>
                                        <div class="line"></div>
                                        <div>预览</div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <TemplatePreview :videoAccount="item.video_account" :showRobot="config.index_robot"
                                        :type="Number(extra.background_type)" :extra="extra" :adminInfo="adminInfo"
                                        :services="services"></TemplatePreview>
                                </div>
                            </div>
                        </div>
                    </pay-box>
                    <pay-box title="基础信息" style="width: 696px;position: relative;" v-if="editTemplate == 1">
                        <div class="card-preview">
                            <mp-card :app-config="config" />
                        </div>
                        <table class="at-table addr-table">
                            <tr>
                                <th>头像</th>
                                <td>
                                    <div class="pdf-uploader-container">
                                        <div class="pdf-uploader">
                                            <upload-image v-model="adminInfo.avatar" @change="triggerPreview" />
                                        </div>
                                    </div>

                                    <div class="tips">建议尺寸，300*300，图片最大为4M</div>
                                </td>
                            </tr>
                            <tr>
                                <th>名称</th>
                                <td>
                                    <at-input v-model="adminInfo.name" class="full-with" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>简介</th>
                                <td>
                                    <a-textarea v-model="adminInfo.summary" class="at-textarea" rows="4"
                                        @change="triggerPreview"></a-textarea>
                                </td>
                            </tr>
                            <tr>
                                <th>电话号码</th>
                                <td>
                                    <at-input v-model="adminInfo.phone" class="full-with" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>邮箱</th>
                                <td>
                                    <at-input v-model="adminInfo.email" class="full-with" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>地址</th>
                                <td>
                                    <at-input class="full-with" v-model="adminInfo.address" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>首页图</th>
                                <td>
                                    <div class="pdf-uploader-container">
                                        <div class="pdf-uploader">
                                            <upload-image v-model="adminInfo.background" @change="triggerPreview" />
                                        </div>
                                    </div>

                                    <div class="tips">建议尺寸，414*985，图片最大为4M</div>
                                </td>
                            </tr>
                            <tr>
                                <th>更多资料页面图片</th>
                                <td>
                                    <div class="pdf-uploader-container">
                                        <div class="pdf-uploader">
                                            <upload-image v-model="adminInfo.detail" @change="triggerPreview"
                                                multiple />
                                        </div>
                                    </div>

                                    <div class="tips">建议尺寸，414*985，图片最大为4M</div>
                                </td>
                            </tr>

                        </table>
                    </pay-box>
                </div>
                <template v-if="editTemplate == 2">

                    <TemplatePreview :videoAccount="item.video_account" :showRobot="config.index_robot"
                        :type="extra.background_type" :extra="extra" :adminInfo="adminInfo" :services="services">
                        <div class="template-select">
                            <div class="select-item" :class="{ active: extra.background_type == '1' }"
                                @click="extra.background_type = 1">
                                <div class="select"></div>
                                <div class="name">背景一</div>
                            </div>
                            <div class="select-item" :class="{ active: extra.background_type == '2' }"
                                @click="extra.background_type = 2">
                                <div class="select"></div>
                                <div class="name">背景二</div>
                            </div>
                            <div class="select-item" :class="{ active: extra.background_type == '3' }"
                                @click="extra.background_type = 3">
                                <div class="select"></div>
                                <div class="name">背景三</div>
                            </div>
                            <div class="select-item" :class="{ active: extra.background_type == '4' }"
                                @click="extra.background_type = 4">
                                <div class="select"></div>
                                <div class="name">背景四</div>
                            </div>
                            <div class="select-item" :class="{ active: extra.background_type == '5' }"
                                @click="extra.background_type = 5">
                                <div class="select"></div>
                                <div class="name">背景五</div>
                            </div>
                            <div class="select-item" :class="{ active: extra.background_type == '6' }"
                                @click="extra.background_type = 6">
                                <div class="select"></div>
                                <div class="name">背景六</div>
                            </div>
                            <div class="select-item" :class="{ active: extra.background_type == '7' }"
                                @click="extra.background_type = 7">
                                <div class="select"></div>
                                <div class="name">背景七</div>
                            </div>
                        </div>
                    </TemplatePreview>

                    <pay-box title="基础信息" style="width: 696px">
                        <div class="basis-info">
                            <div class="info-row">
                                <div class="label">标题</div>
                                <at-input v-model="extra.basic_txt_1" :maxLength="10" placeholder="请输入想展示的标题名称"
                                    class="full-with">
                                    <div class="num">{{ extra.basic_txt_1.length }}/10</div>
                                </at-input>
                            </div>
                            <div class="info-row">
                                <div class="label">使命</div>
                                <at-input v-model="extra.basic_txt_2" :maxLength="30" placeholder="请输入关于‘使命’相关的描述"
                                    class="full-with">
                                    <div class="num">{{ extra.basic_txt_2.length }}/30</div>
                                </at-input>
                            </div>
                            <div class="info-row">
                                <div class="label">理念</div>
                                <at-input v-model="extra.basic_txt_3" :maxLength="30" placeholder="请输入关于‘理念’相关的描述"
                                    class="full-with">
                                    <div class="num">{{ extra.basic_txt_3.length }}/30</div>
                                </at-input>
                            </div>
                            <div class="info-row">
                                <div class="label">愿景</div>
                                <at-input v-model="extra.basic_txt_4" :maxLength="30" placeholder="请输入关于‘愿景’相关的描述"
                                    class="full-with">
                                    <div class="num">{{ extra.basic_txt_4.length }}/30</div>
                                </at-input>
                            </div>
                        </div>
                    </pay-box>
                    <pay-box title="品牌优势" style="width: 696px">
                        <div class="input-row">
                            <at-input v-model="extra.brand_txt_1" :maxLength="16" placeholder="优势一" class="full-with">
                                <div class="num">{{ extra.brand_txt_1.length }}/16</div>
                            </at-input>
                            <at-input v-model="extra.brand_txt_2" :maxLength="16" placeholder="优势二" class="full-with"
                                style="margin-left: 32px;">
                                <div class="num">{{ extra.brand_txt_2.length }}/16</div>
                            </at-input>
                        </div>
                        <div class="input-row">
                            <at-input v-model="extra.brand_txt_3" :maxLength="16" placeholder="优势三" class="full-with">
                                <div class="num">{{ extra.brand_txt_3.length }}/16</div>
                            </at-input>
                            <at-input v-model="extra.brand_txt_4" :maxLength="16" placeholder="优势四" class="full-with"
                                style="margin-left: 32px;">
                                <div class="num">{{ extra.brand_txt_4.length }}/16</div>
                            </at-input>
                        </div>
                        <div class="input-row">
                            <at-input v-model="extra.brand_txt_5" :maxLength="16" placeholder="优势五" class="full-with">
                                <div class="num">{{ extra.brand_txt_5.length }}/16</div>
                            </at-input>
                            <at-input v-model="extra.brand_txt_6" :maxLength="16" placeholder="优势六" class="full-with"
                                style="margin-left: 32px;">
                                <div class="num">{{ extra.brand_txt_6.length }}/16</div>
                            </at-input>
                        </div>
                    </pay-box>
                    <pay-box title="推荐专区" style="width: 696px;position: relative;">
                        <!-- 1. 将 select-box 移出 service-scroll 容器，并加 z-index 保证能被点击 -->
                        <div class="select-box" @click="selectService" style="z-index: 10;">
                            <img src="/assets/images/card-template/card-template-icon1.png">
                            <span>选择服务</span>
                        </div>
                        
                        <!-- 2. ref 绑定的容器内部只留需要拖拽的 service-item -->
                        <div class="service-scroll" ref="serviceScroll">
                            <!-- 3. 注意这里的 key 从 service.title 改为了 service.id，防止 Vue 复用 DOM 出错 -->
                            <div class="service-item" v-for="service in services" :key="service.id"
                                 :data-id="service.id">
                                <div class="sort-icon drag-handle">
                                    <img src="/assets/images/home-sort-icon.png">
                                </div>
                                <div class="del-icon" @click="delService(service)">
                                    <img src="/assets/images/card-template/card-template-icon3.png">
                                </div>
                                <div class="thumb">
                                    <img :src="service.thumb">
                                </div>
                                <div class="info-box">
                                    <div class="row">
                                        <div class="info" style="margin-right: 32px;">
                                            <div class="title">所属板块</div>
                                            <div class="content">
                                                <span v-if="service.group == 'serve'">服务</span>
                                                <span v-if="service.group == 'courses'">课程</span>
                                                <span v-if="service.group == 'activity'">活动</span>
                                            </div>
                                        </div>
                                        <div class="info">
                                            <div class="title">服务标题</div>
                                            <div class="content">{{ service.title }}</div>
                                        </div>
                                    </div>
                                    <div class="info" style="margin-top: 10px;">
                                        <div class="title">服务介绍</div>
                                        <div class="content">{{ service.summary }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </pay-box>
                    <pay-box title="关于我们" style="width: 696px">
                        <table class="at-table addr-table">
                            <tr>
                                <th>头像</th>
                                <td>
                                    <div class="avatar-box" v-if="adminInfo.avatar">
                                        <img :src="adminInfo.avatar" alt="头像">
                                        <div class="image-opera">
                                            <a-button @click="delAvatar()" type="link">
                                                <span class="upload-del"></span>
                                            </a-button>
                                            <a-button @click="preview()" type="link">
                                                <span class="upload-fd"></span>
                                            </a-button>
                                        </div>
                                    </div>
                                    <div class="avatar-uploader" @click="showHeadModal = true" v-else>
                                        <a-icon class="up-icon" :style="{ fontSize: '24px' }" :type="'upload'" />
                                    </div>

                                    <div class="avatar-tips">建议尺寸：144px*144px，图片最大为4M</div>

                                    <!-- <div class="pdf-uploader-container">
                                        <div class="pdf-uploader">
                                            <upload-image v-model="adminInfo.avatar" @change="triggerPreview" />
                                        </div>
                                    </div>

                                    <div class="tips">建议尺寸，300*300，图片最大为4M</div> -->
                                </td>
                            </tr>
                            <tr>
                                <th>名称</th>
                                <td>
                                    <at-input v-model="adminInfo.name" class="full-with" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>简介</th>
                                <td>
                                    <a-textarea v-model="adminInfo.summary" class="at-textarea" rows="4"
                                        @change="triggerPreview"></a-textarea>
                                </td>
                            </tr>
                            <tr>
                                <th>电话号码</th>
                                <td>
                                    <at-input v-model="adminInfo.phone" class="full-with" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>邮箱</th>
                                <td>
                                    <at-input v-model="adminInfo.email" class="full-with" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>地址</th>
                                <td>
                                    <at-input class="full-with" v-model="adminInfo.address" @change="triggerPreview" />
                                </td>
                            </tr>
                            <tr>
                                <th>首页图</th>
                                <td>
                                    <div class="pdf-uploader-container">
                                        <div class="pdf-uploader">
                                            <upload-image v-model="adminInfo.background" @change="triggerPreview" />
                                        </div>
                                    </div>

                                    <div class="tips">建议尺寸，414*985，图片最大为4M</div>
                                </td>
                            </tr>
                            <tr>
                                <th>更多资料
                                    页面图片</th>
                                <td>
                                    <div class="pdf-uploader-container">
                                        <div class="pdf-uploader">
                                            <upload-image v-model="adminInfo.detail" @change="triggerPreview"
                                                multiple />
                                        </div>
                                    </div>

                                    <div class="tips">建议尺寸，414*985，图片最大为4M</div>
                                </td>
                            </tr>
                        </table>
                        <div class="set-btn-box">
                            <service-image>
                                <div class="row set-btn">
                                    <span>私域客服设置</span>
                                    <img src="/assets/images/card-template/card-template-icon4.png">
                                </div>
                            </service-image>
                            <div class="line"></div>
                            <wechat-video @change="triggerPreviewCs">
                                <div class="row set-btn">
                                    <span>视频号显示设置</span>
                                    <img src="/assets/images/card-template/card-template-icon4.png">
                                </div>
                            </wechat-video>
                        </div>
                    </pay-box>
                </template>

            </a-tab-pane>
            <a-tab-pane key="ai" tab="AI检测">
                <div class="tab-summary">
                    说明：AI检测是用户自助拍照进行检测，付费主理人后自动解锁报告，无须人工服务部分，适合初期引流及筛选客户
                </div>
                <div class="at-input-group">
                    <span class="label">
                        <span>AI检测支付价格：</span>
                        <br>
                        <span>(实付金额)</span>
                    </span>
                    <at-input :unit="$app.payment.symbol" v-model="item.detect_ai_pay_price" width="300px"></at-input>
                </div>
                <div class="at-input-group">
                    <span class="label">
                        <span>AI检测划线价格：</span>
                        <br>
                        <span>(显示原价)</span>
                    </span>
                    <at-input :unit="$app.payment.symbol" v-model="item.detect_ai_line_price" width="300px"></at-input>
                </div>
                <div class="at-input-group">
                    <span class="label">
                        <span>支付页面上传：</span>
                    </span>
                    <div class="pdf-uploader-container">
                        <div class="pdf-uploader">
                            <upload-image v-model="item.page_ai_pay_background" />
                            <div style="color: #999;font-size: 12px;">不上传则使用默认支付页面</div>
                        </div>
                    </div>
                </div>
                <div class="at-input-group">
                    <span class="label">
                        <span>海报页面设置：</span>
                    </span>
                    <button class="btn" style="margin-bottom: 10px;" @click="handleEditPoster">
                        海报信息及位置调整
                    </button>
                </div>
            </a-tab-pane>
            <a-tab-pane key="detect" tab="数智诊断">
                <div class="tab-summary">
                    说明：数智诊断产品是，AI数据采集检测+用户档案、生活照上传+主理人人工复诊判断修正，必须要发起实体报告印刷后，才会生成一份电子报告副本。
                    适合将个人形象数智诊断产品做成爆款盈利产品。
                </div>
                <div class="mb-4">
                    <a target="_blank" href="/ast/paper/basic">实体打印报告设置 》》》</a>
                </div>
                <button class="btn" style="margin-bottom: 10px;" @click="handleEditPoster">
                    分享海报设置
                </button>
            </a-tab-pane>
            <a-tab-pane key="service" tab="服务">
                <div class="tab-summary">
                    说明：服务版块，可按课程、服务、活动三种类型（子版块可部分开启）发布商品及详情介绍，可设置价格及用户报名是否需要在线支付等
                </div>
                <div class="at-input-group">
                    <pay-box title="手机页面展示顺序" style="width: 750px">
                        <table class="at-table addr-table">
                            <tr>
                                <th>第一顺序</th>
                                <a-select :value="option1" style="width: 120px" @change="optionsChange1">
                                    <a-select-option v-for="option in options" :key="option.value">
                                        {{ option.label }}
                                    </a-select-option>
                                </a-select>
                                <th>第二顺序</th>
                                <a-select :value="option2" style="width: 120px" @change="optionsChange2">
                                    <a-select-option v-for="option in options2" :key="option.value">
                                        {{ option.label }}
                                    </a-select-option>
                                </a-select>
                                <th>第三顺序</th>
                                <a-select :value="option3" style="width: 120px">
                                    <a-select-option v-for="option in options3" :key="option.value">
                                        {{ option.label }}
                                    </a-select-option>
                                </a-select>
                            </tr>
                        </table>
                    </pay-box>

                </div>
            </a-tab-pane>
            <a-tab-pane key="shop" tab="商城">
                <div class="tab-summary">
                    说明：自营商店商品展示页面，适合以销售商品为主使用
                </div>
            </a-tab-pane>
            <a-tab-pane key="appointment" tab="预约">
                <div class="tab-summary">
                    说明：该版块可以自由创建预约项目，预约项目可绑定产品，在产品购买时自动获得，也可以管理员赠送
                </div>
            </a-tab-pane>
            <a-tab-pane key="scheme" tab="搭配">
                <div class="tab-summary">
                    说明：搭配板块是主理人基于自己小商店商品（自售），结合电商拼图商品，进行提前组合搭配并生成OOTD搭配方案。搭配方案会绑定适合人群风格类型，用户可在手机端进行闲逛浏览及跳转购买。
                    建议销售实体服装的主理人开启使用
                </div>
            </a-tab-pane>
            <a-tab-pane key="cases" tab="案例">
                <div class="tab-summary">
                    说明：案例&分享版块用户可在自由发布，主理人后台审核后可显示在该版块和关联的产品详情页下。用大量真实客户案例见证，增强用户信赖感、激发用户购买欲。
                </div>
            </a-tab-pane>
        </a-tabs>

        <div class="mb-2 row">
            <button @click="saveChange" class="btn">保存</button>
            <button class="pre-btn" v-if="tabKey == 'card' && editTemplate != 0" @click="editTemplate = 0">
                上一步
            </button>
            <img v-else style="width: 342px;height: 32px;margin-left: 4px;" src="/assets/images/save-tips.png">
        </div>

        <PosterModal v-model="showPosterModal" :defaultBackground="posterItem.background"
            :defaultQrcode="posterItem.qrcode" @submit="handlePosterSubmit" @clean="handlePosterClean"></PosterModal>

        <div class="pop-container" v-if="showPop">
            <div class="pop-content">
                <div class="close">
                    <img src="/assets/images/close-icon.png" @click="closePop">
                </div>
                <div class="pop-title">
                    选择服务
                </div>
                <div class="tabs-box">
                    <div class="tabs" :class="{ active: tab.group == serviceGroup }" v-for="tab in modules"
                        :key="tab.group" @click="serviceTabChange(tab)">{{ tab.title }}</div>
                </div>
                <div class="pop-body">
                    <div class="service-item" v-for="service in serviceList" :key="service.id"
                        @click="serviceChange(service)">
                        <div class="select">
                            <img src="/assets/images/card-template/card-template-icon11.png" v-if="service.select">
                            <div v-else></div>
                        </div>
                        <div class="thumb">
                            <img :src="service.thumb">
                        </div>
                        <div class="info-box">
                            <div class="info">
                                <div class="title">服务标题</div>
                                <div class="content">{{ service.title }}</div>
                            </div>
                            <div class="info" style="margin-top: 10px;">
                                <div class="title">服务介绍</div>
                                <div class="content">{{ service.summary }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="foot row">
                    <div class="pagination-box row">
                        <a-pagination class="st-pagination" :current="pager.current" :total="pager.total"
                            :pageSize="pager.pageSize" @change="gotoPage" v-if="pager.total > 0" />
                        <div class="total">共{{ pager.total }}个服务，已选择{{ services.length }}个</div>
                    </div>
                    <div class="btn" @click="selectServiceConfirm">确定</div>
                </div>
            </div>
        </div>

        <template v-if="showPreviewModal">

            <a-modal v-model="showPreviewModal" :footer="null">
                <img class="preview-img" @click="showPreviewModal = false" :src="previewImage" alt="avatar" />
            </a-modal>

        </template>

        <at-modal width="640px" title="修改头像" v-model="showHeadModal" @ok="headImageConfirm">
            <div class="head-tips">
                头像不允许涉及政治敏感与色情; <br>
                图片格式必须为：png,bmp,jpeg,jpg,gif；不可大于4M；实际头像始终为正方形<br>
                建议使用png格式图片，以保持最佳效果；建议图片尺寸为144px*144px
            </div>

            <a-upload :showUploadList="false" name="file" :before-upload="beforeUpload">
                <button class="btn btn-white btn-upload">上传文件</button>
            </a-upload>

            <image-cropper :aspect-ratio="1" :max-width="500" :max-height="500" :image="originalImageBase64"
                v-model="showHeadImageCropper" @cropped="croppedImage" />

            <div class="head-box">
                <div class="head-img-1">
                    <template v-if="base64Avatar">
                        <img :src="base64Avatar" alt="">
                    </template>
                </div>
                <div class="head-img-2">
                    <div class="head-img-title">头像预览</div>
                    <div class="head-img-2-box">

                        <div class="head-img-2-1">
                            <template v-if="base64Avatar">
                                <img :src="base64Avatar" alt="">
                            </template>
                        </div>

                        <div class="head-img-2-2">
                            <template v-if="base64Avatar">
                                <img :src="base64Avatar" alt="">
                            </template>
                        </div>

                    </div>
                </div>
            </div>

        </at-modal>
    </div>
</template>

<script>
import Sortable from "sortablejs";
import api from "@/repo/api";
import AtModal from "@/components/AtModal";
import AtInput from "@/components/AtInput.vue";
import UploadImage from "@/components/UploadImage.vue";
import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
import WechatVideo from "@/views/AST/Xcx/Items/WechatVideo.vue";
import ServiceImage from "@/views/AST/Xcx/Items/ServiceImage.vue";
import PosterModal from "@/components/PosterModal.vue";
import TemplatePreview from "./templatePreview.vue";
import MpCard from "./MpCard.vue";
import ImageCropper from "@/components/ImageCropper.vue";

export default {
    name: "MTabs",
    components: {
        ServiceImage,
        WechatVideo,
        PayBox,
        UploadImage,
        AtInput,
        PosterModal,
        TemplatePreview,
        MpCard,
        ImageCropper,
        AtModal
    },
    props: {
        config: Object
    },
    watch: {
        config() {
            this.init()
        },
        item: {
            deep: true,
            handler(n) {
                this.$emit('serviceSortChange', n.page_service_sort);
            }
        },
        editTemplate() {
            if (this.editTemplate == 0) {
                this.$emit('miniChange', true);
            }
            if (this.editTemplate == 1) {
                this.$emit('miniChange', false);
            }
            if (this.editTemplate == 2) {
                this.$emit('miniChange', true);
            }
        }
    },
    computed: {
        options2() {
            const optionMap = {
                serve: ['courses', 'activity'],
                courses: ['serve', 'activity'],
                activity: ['serve', 'courses']
            };
            return optionMap[this.option1]?.map(value => ({
                value,
                label: { serve: '服务', courses: '课程', activity: '活动' }[value]
            })) || [];
        },
        options3() {
            const remainingOptions = {
                serve_courses: ['activity'],
                serve_activity: ['courses'],
                courses_serve: ['activity'],
                courses_activity: ['serve'],
                activity_serve: ['courses'],
                activity_courses: ['serve']
            };
            const key = `${this.option1}_${this.option2}`;
            return remainingOptions[key]?.map(value => ({
                value,
                label: { serve: '服务', courses: '课程', activity: '活动' }[value]
            })) || [];
        }
    },
    data() {
        return {
            showPop: false,
            editTemplate: 0,
            options: [
                { value: 'serve', label: '服务' },
                { value: 'courses', label: '课程' },
                { value: 'activity', label: '活动' },
            ],
            option1: '',
            option2: '',
            option3: '',
            extra: {
                basic_txt_1: "",
                basic_txt_2: "",
                basic_txt_3: "",
                basic_txt_4: "",
                brand_txt_1: "",
                brand_txt_2: "",
                brand_txt_3: "",
                brand_txt_4: "",
                brand_txt_5: "",
                brand_txt_6: "",
                background_type: 1,
                services: [],
            },
            item: {
                page_card_enabled: "",
                index_robot: "",
                page_ai_enabled: "",
                detect_ai_pay_price: "",
                detect_ai_line_price: "",
                page_ai_pay_background: "",
                page_detect_enabled: "",
                page_service_enabled: "",
                page_shop_enabled: "",
                page_appointment_enabled: "",
                page_scheme_enabled: "",
                page_custom_index_enabled: false,
                page_custom_index_name: "",
                page_custom_index_image: "",
                page_cases_enabled: "",
                page_ai_poster: '',
                page_ai_poster_frame: null,
                page_detect_poster: '',
                page_detect_poster_frame: null,
                page_service_sort: '',
                page_card_style: '',
                video_account: {},
            },
            tabKey: "",
            adminInfo: {},
            enabledPage: undefined,
            showPosterModal: false,
            posterItem: {
                background: undefined,
                qrcode: undefined,
            },
            pager: {
                defaultCurrent: 1,
                current: 1,
                defaultPageSize: 10,
                total: 1,
                pageSize: 15,
            },
            query: {
                page: 1
            },
            modules: [
                {
                    title: '服务',
                    group: 'serve',
                },
                {
                    title: '课程',
                    group: 'courses',
                },
                {
                    title: '活动',
                    group: 'activity',
                },
            ],
            serviceGroup: 'serve',
            serviceList: [],
            services: [],
            showPreviewModal: false,
            previewImage: '',
            showHeadModal: false,
            base64Avatar: '',
            originalImageBase64: '',
            showHeadImageCropper: false,
            pendingServiceChanges: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            for (let key in this.item) {
                this.item[key] = this.config[key]
            }
            let options = this.item.page_service_sort.split(',');
            this.option1 = options[0];
            this.option2 = options[1];
            this.option3 = options[2];
            this.adminInfo = this.config.master_info || {};
            console.log('video_account', this.config.video_account);
            console.log('adminInfo', this.adminInfo);

            if (this.adminInfo.extra && this.adminInfo.extra.background_type) {
                this.extra = this.adminInfo.extra;
            }

            this.sumEnabledPage();

            if (this.extra.services.length) {
                this.defaultList();
            }

            this.initSortScroll();

        },
        headImageConfirm() {
            this.showHeadModal = false;
            this.adminInfo.avatar = this.base64Avatar;
            this.uploadBase64File(this.base64Avatar, 'avatar.jpg');
        },
        uploadBase64File(base64String, fileName) {
            this.$loading.show()

            // 转换为File对象
            const file = this.base64ToFile(base64String, fileName, 'image/jpeg');
            const formData = new FormData();
            formData.append('image', file);
            api.post('/image/upload', formData, (res) => {
                if (res.code == 0) {
                    this.adminInfo.avatar = res.data;
                } else {
                    this.$message.error(res.msg || '上传失败!');
                }
                this.$loading.hide()
            })
        },
        // Base64转Blob
        base64ToBlob(base64Data, contentType = '') {
            // 移除Base64字符串的前缀（如果有）
            const base64WithoutPrefix = base64Data.split(',')[1] || base64Data;

            const byteCharacters = window.atob(base64WithoutPrefix);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, { type: contentType });
        },
        // 创建可上传的File对象
        base64ToFile(base64Data, fileName, mimeType = '') {
            const blob = this.base64ToBlob(base64Data, mimeType);
            return new File([blob], fileName, { type: mimeType });
        },
        croppedImage(image) {
            this.base64Avatar = image
        },
        beforeUpload(p) {

            this.getBase64(p).then((base64) => {

                this.originalImageBase64 = base64

                this.showHeadImageCropper = true

            })

            return false;
        },
        getBase64(file) {

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });

        },
        delAvatar() {
            this.adminInfo.avatar = '';
        },
        preview() {
            this.previewImage = this.adminInfo.avatar || '';
            this.showPreviewModal = true
        },
        closePop() {
            this.showPop = false;
        },
        selectServiceConfirm() {
            // 应用所有暂存的修改操作
            this.pendingServiceChanges.forEach(change => {
                if (change.type === 'add') {
                    // 添加到 services
                    if (this.services.findIndex(s => s.id === change.item.id) === -1) {
                        this.services.push(change.item);
                    }
                    // 添加到 extra.services
                    if (this.extra.services.indexOf(change.item.id) === -1) {
                        this.extra.services.push(change.item.id);
                    }
                } else if (change.type === 'remove') {
                    // 从 services 中移除
                    let index = this.services.findIndex(s => s.id === change.item.id);
                    if (index > -1) {
                        this.services.splice(index, 1);
                    }
                    // 从 extra.services 中移除
                    let idx = this.extra.services.indexOf(change.item.id);
                    if (idx > -1) {
                        this.extra.services.splice(idx, 1);
                    }
                }
            });

            // 清空暂存的操作
            this.pendingServiceChanges = [];

            // 调用保存
            this.saveInfo();
            this.showPop = false;
        },
        selectService() {
            this.showPop = true;
            this.pendingServiceChanges = []; // 清空暂存的操作
            this.getList();
        },
        gotoPage(page) {
            this.query.page = page
            this.getList()
        },
        initSortScroll() {
            const el = this.$refs.serviceScroll;
            if (!el) {
                // 间隔500ms再调用
                setTimeout(() => {
                    this.initSortScroll();
                }, 500);
                return;
            }
            // 使用Sortable.js实现拖拽排序
            Sortable.create(el, {
                handle: '.drag-handle',
                animation: 150,
                onEnd: (evt) => {
                    const oldIndex = evt.oldIndex;
                    const newIndex = evt.newIndex;
                    
                    // 如果位置没变，直接返回
                    if (oldIndex === newIndex) return;
                    
                    // 1. 同步更新视图绑定的对象数组 (保证UI所见即所得)
                    const servicesCopy = [...this.services];
                    const movedService = servicesCopy.splice(oldIndex, 1)[0];
                    servicesCopy.splice(newIndex, 0, movedService);
                    this.services = servicesCopy; // 触发 Vue 响应式更新
                    
                    // 2. 同步更新数据源绑定的 ID 数组 (保证传给后端的数据正确)
                    const extraServicesCopy = [...this.extra.services];
                    const movedId = extraServicesCopy.splice(oldIndex, 1)[0];
                    extraServicesCopy.splice(newIndex, 0, movedId);
                    this.extra.services = extraServicesCopy;
                    
                    // 3. 触发父组件更新
                    this.$set(this.adminInfo, 'extra', this.extra);
                    this.$emit('change', 'master-info', this.adminInfo);
                }
            });
        },
        saveInfo() {
            this.adminInfo.extra = this.extra;
            this.$emit('change', 'master-info', this.adminInfo)
        },
        defaultList() {
            let id_list = '';
            id_list = this.extra.services.join(',');

            api.get('/course/list', { id_list }, (res) => {
                console.log('res1', res.data.data);
                console.log('res2', this.extra.services);
                let arr = this.sortDataByIds(res.data.data || [], this.extra.services);
                console.log('arr', arr);
                arr.forEach(item => {
                    this.$set(item, 'select', true);
                })
                this.services = arr || [];
            })
        },
        sortDataByIds(data, ids) {
            console.log('sortDataByIds input:', { data, ids });

            // 确保数据类型一致，将id都转换为字符串进行比较
            const stringIds = ids.map(id => String(id));

            // 创建一个 id 到数据的映射
            const dataMap = new Map();
            data.forEach(item => {
                dataMap.set(String(item.id), item);
            });

            // 按照 ids 的顺序构建新数组
            const sortedData = [];
            stringIds.forEach(id => {
                if (dataMap.has(id)) {
                    sortedData.push(dataMap.get(id));
                    dataMap.delete(id); // 避免重复添加
                }
            });

            // 添加不在 ids 中的剩余数据
            dataMap.forEach(item => {
                sortedData.push(item);
            });

            console.log('sortDataByIds output:', sortedData);
            return sortedData;
        },
        getList() {
            this.query.group = this.serviceGroup;
            api.get('/course/list', this.query, (res) => {
                res.data.data.forEach(item => {
                    let index = this.extra.services.indexOf(item.id);
                    if (index > -1) {
                        this.$set(item, 'select', true);
                    }
                })
                this.serviceList = res.data.data || [];
                this.pager.current = res.data.current_page;
                this.pager.total = res.data.total;
                this.pager.pageSize = res.data.per_page;
            })
        },
        serviceTabChange(item) {
            this.serviceGroup = item.group;
            this.getList();
        },
        serviceChange(item) {
            // 不再立即修改数据，而是记录操作到暂存数组
            if (item.select) {
                // 记录移除操作
                this.pendingServiceChanges.push({
                    type: 'remove',
                    item: item
                });
                // 只更新UI状态，不修改实际数据
                this.$set(item, 'select', false);
            } else {
                // 记录添加操作
                this.pendingServiceChanges.push({
                    type: 'add',
                    item: item
                });
                // 只更新UI状态，不修改实际数据
                this.$set(item, 'select', true);
            }
        },
        delService(service) {
            console.log('delservice', service);

            // 彻底从 services 数组中移除
            let index = this.services.findIndex(s => s.id === service.id);
            if (index > -1) {
                this.services.splice(index, 1);
            }

            // 从 extra.services 中移除
            let idx = this.extra.services.indexOf(service.id);
            if (idx > -1) {
                this.extra.services.splice(idx, 1);
            }

            console.log('delservice after:', this.services);
            console.log('delservice extra after:', this.extra.services);

            // 删除服务后调用保存
            this.saveInfo();
        },
        optionsChange1(val) {
            this.option1 = val;
            this.option2 = this.options2[0].value;
            this.option3 = this.options3[0].value;
            this.item.page_service_sort = val + ',' + this.option2 + ',' + this.option3;
        },
        optionsChange2(val) {
            this.option2 = val;
            this.option3 = this.options3[0].value;
            this.item.page_service_sort = this.option1 + ',' + val + ',' + this.option3;

        },
        tabChange(val) {
            this.tabKey = val
            this.$emit('tabChange', val)
        },
        sumEnabledPage() {
            setTimeout(() => {

                const list = [
                    'page_custom_index_enabled',
                    'page_card_enabled',
                    'page_ai_enabled',
                    'page_detect_enabled',
                    'page_service_enabled',
                    'page_scheme_enabled',
                    'page_shop_enabled',
                    'page_cases_enabled',
                    'page_appointment_enabled',
                ];

                let num = 0

                list.forEach(key => {
                    if (this.item[key]) num++
                })

                if (this.enabledPage !== undefined) {
                    this.triggerPreview()
                }

                this.enabledPage = num;

            }, 50)
        },
        isDisabled(key) {
            if (this.enabledPage === undefined) return false;

            return (!this.item[key]) && this.enabledPage >= 4;
        },
        triggerPreviewCs(item) {
            this.$set(this.item, 'video_account', item.video_account);
            this.$emit('preview', 'pages', item);
        },
        triggerPreview() {
            this.$emit('preview', 'pages', this.item)
        },
        saveChange() {
            // 先清空 extra.services，然后重新添加
            this.extra.services = [];

            // 只添加当前选中的 services
            this.services.forEach(item => {
                if (item.select) {
                    this.extra.services.push(item.id);
                }
            });

            this.adminInfo.extra = this.extra;
            this.$emit('change', 'pages', this.item)
            this.$emit('change', 'master-info', this.adminInfo)
        },
        handleEditPoster() {
            this.showPosterModal = true
            switch (this.tabKey) {
                case "ai": {
                    if (this.item.page_ai_poster) {
                        this.posterItem.background = {
                            imageUrl: this.item.page_ai_poster ?? '',
                            w: this.item.page_ai_poster_frame.background.w ?? 0,
                            h: this.item.page_ai_poster_frame.background.h ?? 0,
                        }
                        this.posterItem.qrcode = {
                            w: this.item.page_ai_poster_frame.qrcode.w ?? 0,
                            h: this.item.page_ai_poster_frame.qrcode.h ?? 0,
                            l: this.item.page_ai_poster_frame.qrcode.l ?? 0,
                            t: this.item.page_ai_poster_frame.qrcode.t ?? 0,
                        }
                    } else {
                        this.posterItem.background = null
                        this.posterItem.qrcode = null
                    }
                }
                    break
                case "detect": {
                    if (this.item.page_detect_poster) {
                        this.posterItem.background = {
                            imageUrl: this.item.page_detect_poster ?? '',
                            w: this.item.page_detect_poster_frame.background.w ?? 0,
                            h: this.item.page_detect_poster_frame.background.h ?? 0,
                        }
                        this.posterItem.qrcode = {
                            w: this.item.page_detect_poster_frame.qrcode.w ?? 0,
                            h: this.item.page_detect_poster_frame.qrcode.h ?? 0,
                            l: this.item.page_detect_poster_frame.qrcode.l ?? 0,
                            t: this.item.page_detect_poster_frame.qrcode.t ?? 0,
                        }
                    } else {
                        this.posterItem.background = null
                        this.posterItem.qrcode = null
                    }
                }
                    break
            }
        },
        handlePosterSubmit({ background, qrcode }) {
            const poster = background.imageUrl
            const frame = {
                background: {
                    w: background.w,
                    h: background.h,
                },
                qrcode: {
                    w: qrcode.w,
                    h: qrcode.h,
                    l: qrcode.l,
                    t: qrcode.t,
                },
            }
            switch (this.tabKey) {
                case "ai": {
                    this.item.page_ai_poster = poster
                    this.item.page_ai_poster_frame = frame
                }
                    break
                case "detect": {
                    this.item.page_detect_poster = poster
                    this.item.page_detect_poster_frame = frame
                }
                    break
                default: {
                    console.error("错误的tabKey")
                    return
                }
            }
            this.showPosterModal = false
            this.saveChange()
        },
        handlePosterClean() {
            switch (this.tabKey) {
                case "ai": {
                    this.item.page_ai_poster = ""
                    this.item.page_ai_poster_frame = null
                }
                    break
                case "detect": {
                    this.item.page_detect_poster = ""
                    this.item.page_detect_poster_frame = null
                }
                    break
                default: {
                    console.error("错误的tabKey")
                    return
                }
            }
            this.showPosterModal = false
            this.saveChange()
        },
    }
}
</script>

<style scoped lang="less">
.card-preview {
    position: absolute;
    left: 720px;
    top: 0;
    width: 280px;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.template-select {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    top: 1424px;
    left: 0;
    z-index: 10;

    .select-item {
        display: flex;
        align-items: center;
        margin-right: 32px;
        margin-bottom: 32px;
        cursor: pointer;

        .select {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            border: 1px solid #999999;
            margin-right: 8px;
        }

        .name {
            color: #999999;
            font-size: 14px;
        }
    }

    .active {
        .select {
            background: #333333;
            border: none;
            position: relative;

            &:after {
                content: "";
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #FFFFFF;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .name {
            color: #333333;
            font-size: 14px;
        }
    }
}

.set-btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    cursor: pointer;

    .line {
        width: 1px;
        height: 20px;
        background: #EEEEEE;
        margin: 0 24px;
    }

    .set-btn {
        img {
            width: 20px;
            height: 20px;
            margin-left: 10px;
        }

        span {
            color: #FBB03B;
            font-size: 14px;
        }
    }
}

.pop-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;

    .pop-content {
        width: 1368px;
        height: 810px;
        background: #fff;
        position: relative;

        .foot {
            width: 100%;
            height: 72px;
            border-top: 1px solid #EEEEEE;
            padding: 0 24px;
            justify-content: space-between;

            .pagination-box {
                color: #333333;
                font-size: 14px;

                .total {
                    margin-left: 16px;
                }
            }
        }

        .pop-body {
            width: 100%;
            height: calc(100% - 198px);
            margin-top: 16px;
            padding: 0 24px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: flex-start;
            overflow: scroll;
            overflow-x: hidden;

            .service-item {
                margin-bottom: 24px;
            }
        }

        .tabs-box {
            display: flex;
            align-items: center;
            margin-top: 16px;
            padding: 0 24px;

            .tabs {
                width: 92px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #FFFFFF;
                border: 1px solid #EEEEEE;
                margin-right: 16px;
                cursor: default;
            }

            .active {
                color: #fff;
                background: #333333;
                border: 1px solid #333333;
            }
        }

        .pop-title {
            width: 100%;
            height: 62px;
            line-height: 62px;
            color: #333;
            font-size: 16px;
            font-weight: bold;
            padding-left: 24px;
            border-bottom: 1px solid #EEEEEE;
        }

        .close {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

.basis-info {
    width: 100%;

    .info-row {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 32px;

        &:last-child {
            margin-bottom: 0;
        }

        .label {
            width: 100px;
            font-size: 14px;
            color: #333333;
            text-align: center;
        }

        .input-box {
            width: 550px;
            width: 507px;
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
        }

        .num {
            color: rgba(0, 0, 0, 0.25);
            line-height: 40px;
            padding: 0 12px;
        }
    }
}

.input-row {
    width: 100%;
    display: flex;
    align-items: center;

    .num {
        color: rgba(0, 0, 0, 0.25);
        line-height: 40px;
        padding: 0 12px;
    }

    margin-bottom: 32px;

    &:last-child {
        margin-bottom: 0;
    }
}

.select-box {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;

    img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }

    span {
        color: #FBB03B;
        font-size: 14px;
    }
}

.service-item {
    width: 648px;
    height: 180px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    display: flex;
    padding: 24px;
    cursor: default;
    position: relative;
    margin-bottom: 24px;

    .select {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 16px;
        right: 16px;

        img {
            width: 24px;
            height: 24px;
        }

        div {
            width: 24px;
            height: 24px;
            background: #FFFFFF;
            border: 2px solid rgba(0, 0, 0, 0.4);
            border-radius: 50%;
        }
    }

    .sort-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .del-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .thumb {
        width: 224px;
        height: 132px;
        border: 1px solid #EEEEEE;
        margin-right: 16px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .info-box {
        flex: 1;

        .info {
            .title {
                color: #999999;
                font-size: 14px;
                line-height: 20px;
            }

            .content {
                color: #333333;
                font-size: 16px;
                font-weight: 500;
                line-height: 22px;
                margin-top: 8px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
        }
    }
}

.pre-btn {
    width: 94px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    color: #333333;
    font-size: 14px;
    border: 1px solid #333333;
    background: #FFFFFF;
    margin-left: 20px;
}

.row {
    display: flex;
    align-items: center;
}

.card-templates {
    display: flex;

    .card-template {
        width: 280px;
        margin-right: 32px;

        .card-head {
            width: 280px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                display: flex;
                align-items: center;
                cursor: pointer;

                .point {
                    width: 14px;
                    height: 14px;
                    background: #FFFFFF;
                    border-radius: 50%;
                    border: 1px solid #999999;
                    margin-right: 8px;
                }

                .label {
                    color: #999999;
                    font-size: 14px;
                }
            }

            .right {
                display: flex;
                align-items: center;
                color: #FBB03B;
                font-size: 14px;
                cursor: pointer;

                .line {
                    width: 1px;
                    height: 16px;
                    background-color: rgba(0, 0, 0, 0.1);
                    margin: 0 4px;
                }
            }
        }

        .card-body {
            width: 284px;
            height: 610px;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
            margin-top: 16px;
            overflow: hidden;
            cursor: pointer;
            position: relative;

            .template-preview-box {
                top: 0;
                left: 0;
            }
        }
    }

    .template-active {
        .card-head {
            .left {
                .point {
                    background: #333333;
                    border: 1px solid #333333;
                }
            }
        }

        .card-body {
            border: 2px solid #333333;
        }
    }
}

.pay-apply-tips {
    width: 300px;
    padding-left: 16px;
}

.tab-summary {
    margin-bottom: 16px;
    width: 750px;
}

.pdf-uploader-container {
    display: flex;
    justify-content: flex-start;
}

.avatar-box {
    width: 104px;
    height: 104px;
    border: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .image-opera {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.4);
        line-height: 0;
        opacity: 0;
        /* 默认隐藏 */
        transition: opacity 0.3s ease;
        /* 添加过渡效果 */

        .upload-del,
        .upload-fd {
            display: block;
            width: 20px;
            height: 20px;
            background-image: url("/assets/icons/upload-del.png");
            background-size: 20px;
        }

        .upload-fd {
            background-image: url("/assets/icons/upload-fd.png");
        }
    }

    &:hover {
        .image-opera {
            opacity: 1;
            /* 悬停时显示 */
        }
    }
}

.avatar-uploader {
    width: 104px;
    height: 104px;
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-tips {
    color: #999999;
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
}

.preview-img {
    width: 100%;
}

.head-tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
}

.btn-upload {
    width: 96px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #333333;
    line-height: 32px;
    padding: 0;
    margin-top: 16px;
    font-size: 14px;
    color: #333333;

    &:hover {
        color: #333333;
    }
}

.head-box {
    margin-top: 20px;
    display: flex;
    flex-direction: row;

    img {
        width: 100%;
        height: 100%;
    }
}

.head-img-title {
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 14px;
}

.head-img-1 {
    width: 200px;
    height: 200px;
    background: #F5F5F5;
    margin-right: 24px;
    overflow: hidden;
}

.head-img-2 {
    background: #F5F5F5;
    flex: 1;
    height: 200px;
    padding-left: 24px;
}

.head-img-2-box {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
}

.head-img-2-1 {
    width: 144px;
    height: 144px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-right: 28px;
    overflow: hidden;
}

.head-img-2-2 {
    width: 144px;
    height: 144px;
    background: #FFFFFF;
    border-radius: 50%;
    overflow: hidden;
}

.addr-input {
    width: 100%;
    margin-bottom: 5px;
}

.addr-table {
    width: 100%;
    border: none;

    th {
        background-color: transparent;
        width: 90px;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
        font-weight: normal;

        text-align: right;
    }

    td {
        text-align: left;
    }

    tr,
    th,
    td {
        border: none;
    }
}
</style>